/* eslint-disable no-restricted-syntax */

/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Link, Typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';
import getProductTitle from 'bundles/unified-common/utils/getProductTitle';
import Modal from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import type { ModalProps } from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
import type { SpecializationFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCourseEntitiesFragments';

import _t from 'i18n!nls/xdp';

const styles = {
  titleDivider: (theme: Theme) => css`
    border-bottom: 2px solid ${theme.palette.gray[300]};
  `,
  linkContainer: (theme: Theme) => css`
    border-bottom: 2px solid ${theme.palette.gray[300]};
    padding: ${theme.spacing(16, 0)};
  `,
  specializationLink: (theme: Theme) => css`
    text-decoration-color: ${theme.palette.black[500]};
  `,
  specializationLinkText: css`
    font-weight: 600;
  `,
};

type Props = ModalProps & {
  specializations: Array<SpecializationFragment>;
};

const MultipleSpecializationsModal = ({ specializations, ...rest }: Props) => {
  const { getSpecializationLink } = usePageInfo();
  return (
    <Modal {...rest} header={_t('This course is part of multiple programs')}>
      <div css={styles.titleDivider} />
      {specializations.map((specialization) => (
        <div css={styles.linkContainer}>
          <Link
            component={TrackedLink2}
            href={getSpecializationLink({
              productSlug: specialization.slug,
              productVariant: specialization.productVariant,
            })}
            trackingName="hero_program_modal_link"
            typographyVariant="bodyPrimary"
            target="_blank"
            css={styles.specializationLink}
          >
            <Typography2 component="span" variant="bodyPrimary" css={styles.specializationLinkText}>
              {getProductTitle(specialization.name, specialization.productVariant)}
            </Typography2>
          </Link>
        </div>
      ))}
    </Modal>
  );
};

export default MultipleSpecializationsModal;
